// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/nodes/HangupNode.js (71 lines).
 * BYTE-IDENTICAL — reactflow → @xyflow/react import swap only.
 */
import React, { useContext, useState } from 'react';
import { Handle } from '@xyflow/react';
import { NodesContext } from '../provider/IvrContext';
import WebhookSelectModal from '../Helpers/WebhookSelectModal';
import { toast } from 'sonner';
import { PhoneOff, Link2, Trash2, CheckCircle2 } from 'lucide-react';
import { triggerHandleConnect } from '../Helpers/utils';

const COLOR = '#dc2626';

const HangupNode = ({ data, id }: any) => {
  const { onRemove, webhookList, smsWebhookList, updateNodeData } =
    useContext(NodesContext) as any;
  const [webhookModalOpen, setWebhookModalOpen] = useState(false);
  const webhookConfig = data?.webhookConfig || null;

  const saveWebhookConfig = (cfg: any) => {
    updateNodeData(id, { webhookConfig: cfg });
    toast.success(cfg ? 'Webhook saved.' : 'Webhook cleared.');
  };

  return (
    <div className="ivrn" style={{ '--node-color': COLOR } as any}>
      <span
        className="ivrn-icon"
        style={{ background: COLOR, color: '#fff' }}
        onClick={triggerHandleConnect}
      >
        <PhoneOff size={22} strokeWidth={2} />
      </span>
      <Handle
        type="target"
        position={'left' as any}
        id="new-target-handle-hangup"
        style={{ background: COLOR, top: '65%' }}
      />

      <div className="ivrn-head">
        <span className="ivrn-title">Hangup</span>
        <span className="ivrn-badge ivrn-badge--red">END</span>
      </div>

      <div className="ivrn-body">
        {webhookConfig ? (
          <span className="ivrn-val">
            <CheckCircle2
              size={10}
              style={{ color: COLOR, marginRight: 4, flexShrink: 0 }}
            />
            Webhook linked
          </span>
        ) : (
          <span className="ivrn-hint">Terminates the call</span>
        )}
      </div>

      <div className="ivrn-actions">
        <button
          className={`ivrn-btn ivrn-btn--link${webhookConfig ? ' active' : ''}`}
          title="Webhook"
          onClick={() => setWebhookModalOpen(true)}
        >
          <Link2 size={14} strokeWidth={2} />
        </button>
        <button
          className="ivrn-btn ivrn-btn--del"
          title="Remove"
          onClick={() => onRemove(id)}
        >
          <Trash2 size={14} strokeWidth={2} />
        </button>
      </div>

      <WebhookSelectModal
        show={webhookModalOpen}
        onClose={() => setWebhookModalOpen(false)}
        value={webhookConfig}
        onSave={saveWebhookConfig}
        webhookList={webhookList}
        smsWebhookList={smsWebhookList}
        title="Hangup Node Webhook"
      />
    </div>
  );
};

export default HangupNode;
